// extracted by mini-css-extract-plugin
export var formContainer = "_is-0";
export var message = "_is-1";